import React, { useEffect, useLayoutEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom';
import ExpandedCard from './modals/ExpandedCard';
import { debouncedGetChooseJob, debouncedGetJobVehicleImgs, resetJobVehicleImgs, resetOpenJob, setIsNewJob } from '../store/job/actions';
import { initializePusher, unbindPusher } from '../pusherManager';
import { getCookie } from '../helpers/globals';
import { getNoteList, resetJobNotes } from '../store/note/actions';


export const JobModal = (props) => {
    const modalRef = React.useRef(null);
    const [selectedJob, setSelectedJob] = useState(props.newJob.data);
    const [archivedJob, setArchivedJob] = useState(false);
    const [pulseAnimation, setPulseAnimation] = useState(false)

    const history = useHistory();
    const { isNewJob, setIsNewJob } = props
    const orgId = getCookie('active_organization_id')

    useEffect(() => {
        if (!selectedJob?.id) return;
        props.resetJobVehicleImgs();
        props.resetJobNotes();
    }, [selectedJob?.id]);

    const closeJobModal = () => {
        window.history.pushState({}, '', `#${history.location.pathname}`)
        props.resetOpenJob()
        props.resetJobVehicleImgs();
        props.resetJobNotes();
        setIsNewJob(false)

        if (props.newJob?.isFirstJob) {
            history.push("/planning")
        }
    }

    // The board already has the job's core fields (color, ro_number, customer,
    // vehicle, etc.) from the list it just clicked on. Show that immediately
    // instead of waiting on the AJAX call, so nothing has to flash in.
    useEffect(() => {
        const handleQuickOpen = (e) => {
            if (e.detail) {
                setSelectedJob(e.detail)
                props.getVehicleImages(e.detail.id);
                props.getNoteList(e.detail.id);
            }
        };
        window.addEventListener('jobCardQuickOpen', handleQuickOpen);
        return () => window.removeEventListener('jobCardQuickOpen', handleQuickOpen);
    }, []);

    useLayoutEffect(() => {
        const hasJobData = props.newJob.data && Object.keys(props.newJob.data).length > 0;
        if (isNewJob && !hasJobData) {
            setSelectedJob({});
            props.resetJobVehicleImgs();
            props.resetJobNotes();
            return;
        }

        // Only take over once the server data has actually arrived - don't let
        // an in-flight "loading" state wipe out the quick data we already showed.
        if (!props.newJob.loading && hasJobData) {
            setSelectedJob(prev => ({
                ...prev,
                ...props.newJob.data
            }));
        }
    }, [isNewJob, props.newJob.data, props.newJob.loading])

    
    const changeBackground = (color) => {
        setSelectedJob({ ...selectedJob, color_id: color?.id, job_color: color })
    }

    const onArchiveJob = (status) => {
        // status - 0: archive, 1: unarchive
        if (status === 0) {
            setArchivedJob(true)
        } else if (status === 1) {
            setPulseAnimation(false)
            setArchivedJob(false)
            setTimeout(() => {
                setPulseAnimation(false)
            }, 5000)
        }
    }

    return (
        <>
            <div className="expandedcard_section">
                <div
                    id="expandCard"
                    className={`${pulseAnimation ? `pulseAni` : ''}`}
                >
                    <div className='card-color-line' style={{
                        background:
                            (props?.colorList?.data?.length > 0 && selectedJob?.color_id) ?
                                `linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.25) 100%), ${props?.colorList?.data.find(data => { return data?.id === selectedJob?.color_id })?.['color']}`
                                : ''
                    }} />
                    <div
                        className="expandedcard_modal"
                        style={{ backgroundColor: 'white' }}
                    >
                        <ExpandedCard
                            isCardChanged={false}
                            item={selectedJob}
                            changeBackground={(color) => changeBackground(color)}
                            currentUser={props.user}
                            loading={props.newJob.loading && Object.keys(selectedJob || {}).length === 0}
                            onArchiveJob={() => onArchiveJob()}
                            isNewJob={isNewJob} />
                    </div>
                    <img ref={modalRef}
                        className="extend-modal-close modal-close"
                        alt=""
                        src={require(
                            '../assets/images/production_board/modal-close.svg').default}
                        onClick={(e) => {
                            e.preventDefault()
                            closeJobModal()
                        }}
                    />
                </div>
            </div>
            <div className="expandCardBack"
                onClick={(e) => {
                    e.preventDefault()
                    closeJobModal()
                }}
            ></div>
        </>
    )
}

const mapStateToProps = (state) => ({
    jobStatuses: state.JobReducer.jobStatuses,
    colorList: state.JobReducer.colorList,
    assignedUsers: state.JobReducer.assignedUsers,
    filterOptions: state.JobReducer.filterOptions,
    user: state.UserReducer.user,
    newJob: state.JobReducer.newJob,
    isNewJob: state.JobReducer.isNewJob
})

const mapDispatchToProps = (dispatch) => {
    return {
        debouncedGetChooseJob: (id, loading) => debouncedGetChooseJob(dispatch, id, loading),
        resetOpenJob: () => dispatch(resetOpenJob()),
        setIsNewJob: (isNew) => dispatch(setIsNewJob(isNew)),
        resetJobVehicleImgs: () => dispatch(resetJobVehicleImgs()),
        resetJobNotes: () => dispatch(resetJobNotes()),
        getVehicleImages: (id) => debouncedGetJobVehicleImgs(dispatch, id),
        getNoteList: (jobId) => dispatch(getNoteList(jobId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(JobModal)